export default __webpack_public_path__ + "static/MediaContentFourteen-849ab353b2ed727b562175372cdeb2d8.webp";